__turbopack_context__.v({
  "description": "_5N6hLa_description",
  "link": "_5N6hLa_link",
  "root": "_5N6hLa_root",
  "title": "_5N6hLa_title",
});
